'use client';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Image from 'next/image';
import LinearProgress from '@mui/material/LinearProgress';
import { useRouter } from 'next/navigation';
import type { MouseEventHandler } from 'react';

import { useIfaStore } from '@ifa/store';
import { theme } from '@ifa/ui/theme';

import nmdp_whitetext_svg from '../../../public/images/nmdp_whitetext.svg';

import AuthButton from './AuthButton';

//TODO
// const DynamicAuthButton = dynamic(async () => import('./AuthButton'));
// const DynamicPreviewIndicator = dynamic(
//   async () => import('../PreviewIndicator').then((mod) => mod.PreviewIndicator),
//   { ssr: false }
// );

export default function ResponsiveAppBar() {
    const appStatus = useIfaStore(state => state.app.status);
    const router = useRouter();

    const handleClickLogo: MouseEventHandler<HTMLDivElement> = e => {
        e.preventDefault();
        router.push('/');
    };

    return (
        <AppBar
            position="fixed"
            sx={{
                top: '0px',
                left: '0px',
                right: '0px',
                height: '64px',
            }}
            elevation={4}
        >
            <Box
                sx={{
                    top: '0',
                    left: '0',
                    width: '100%',
                    padding: '0',
                    height: '5px',
                    position: 'absolute',
                    backgroundColor: theme.palette.primary.main,
                }}
            >
                {appStatus === 'fetching' && (
                    <LinearProgress
                        sx={{
                            backgroundColor: appStatus === 'fetching' ? '#7A961D' : theme.palette.primary.main,
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        }}
                    />
                )}
            </Box>
            <Toolbar>
                <Box
                    sx={{
                        textDecoration: 'none',
                        display: 'flex',
                        height: 'auto',
                        mr: 3,
                        cursor: 'pointer',
                    }}
                    onClick={handleClickLogo}
                >
                    <Image width="120" height="40" src={nmdp_whitetext_svg} alt={`nmdp logo`} priority={true} />
                </Box>
                <Box
                    sx={{
                        flexGrow: 1,
                        display: { xs: 'flex', md: 'inline' },
                        alignItems: 'center',
                        justifyContent: 'left',
                    }}
                >
                    <Typography
                        variant="h3"
                        sx={{
                            mr: 3,
                            color: 'inherit',
                            textDecoration: 'none',
                            display: { xs: 'none', sm: 'inline' },
                        }}
                    >
                        International Forms Creation
                    </Typography>
                </Box>
                <Box
                    sx={{
                        flexGrow: 0,
                        mx: '1rem',
                        my: 'auto',
                        display: 'flex',
                    }}
                >
                    {/* <DynamicPreviewIndicator /> */}
                </Box>
                <Box sx={{ flexGrow: 0 }}>
                    <AuthButton />
                </Box>
            </Toolbar>
        </AppBar>
    );
}
